import styled from "styled-components";

export const DivForm = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 50px 0 100px;

  .input-link {
    width: 100%;
    height: 49px;
    border-radius: 4px 0px 0px 4px;
    padding: 16px;
    background-color: #f5f5f5;
    color: #616161;
    border: none;
    outline: none;
  }

  .copy-button,
  .download-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    background-color: #6c5af4;
    border: none;
    outline: none;
    padding: 1rem;
    width: 160px;
    height: 50px;
    font-size: 16px;
    font-weight: 700;
  }

  .copy-button {
    border-radius: 0 4px 4px 0;
  }

  .download-button {
    border-radius: 8px;
  }
`;

export const BtnContact = styled.button`
  background-color: #6c5af4;
  border-radius: 6px;
  color: #ffffff;
  border: none;
  height: 50px;
  width: 166px;

  &:disabled {
    background-color: grey;
  }

  @media (max-width: 500px) {
    margin-left: 0;
  }
`;

export const BtnPDF = styled.div`
  whitespace: nowrap;

  @media (max-width: 500px) {
    margin-left: 0;
  }
`;

export const Title = styled.div`
  font-family: "Kanit", sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  color: #212121;
  margin-bottom: 10px;
  text-align: left;
  max-width: 922px;
  margin: 20px auto;
`;

export const TitleStatus = styled.div`
  font-family: "Kanit", sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  color: #6c5af4;
  margin-bottom: 10px;
  text-align: right;
  max-width: 922px;
`;

export const SetaVoltar = styled.img`
  cursor: pointer;
`;

export const TopGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
  width: 100%;
  max-width: 922px;
  margin: 0 auto;

  @media (max-width: 900px) {
    grid-template-columns: repeat(3, 1fr); /* 3 colunas */
  }

  @media (max-width: 700px) {
    grid-template-columns: repeat(2, 1fr); /* 2 colunas */
  }

  @media (max-width: 500px) {
    grid-template-columns: 1fr; /* 1 coluna */
  }
`;

export const GridButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-width: 922px;
  margin: 0px auto;
  @media (max-width: 700px) {
    justify-content: center;
  }
`;

export const GridInputs = styled.div`
  max-width: 922px;
  margin: 0 auto;
`;

export const TitleValue = styled.div`
  font-family: "Kanit", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 18.75px;
  color: #212121;
`;

export const TextValue = styled.div`
  font-family: "Kanit", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 18.75px;
  color: #6c5af4;

  .show {
    display: none;
    width: auto;
    height: auto;
    background: #fafafa;
    box-shadow: 0px 30px 60px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    border: 1px solid #d5d5d5;
    opacity: 1;
    position: absolute;
    z-index: 1;
    text-align: left;
    letter-spacing: 0px;
    padding: 10px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #000000;
    display: block;
    cursor: pointer;
    word-wrap: break-word;
    max-width: 250px;
  }

  .hide {
    display: none;
  }
`;

export const TextValueDecoration = styled.a`
  font-family: "Kanit", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 18.75px;
  color: #6c5af4;

  &:hover {
    text-decoration: none;
    color: #6c5af4;
  }
`;

export const TextArea = styled.textarea`
  font-family: Kanit, sans-serif;
  font-size: 16px;
  font-weight: 100;
  color: #000000;
  padding: 10px;
  resize: auto;
  border: 1px solid #d9d9d9;
  min-width: 180px;
  max-width: 100%;
  max-height: 150px;
  width: 100%;

  &:focus-visible {
    outline: none;
  }
`;

export const ButtonOK = styled.button`
  margin: 0 10px;
  padding: 8px 16px;
  font-size: 14px;
  border: none;
  background-color: #6c5af4;
  color: #ffffff;
  max-width: 100px;
  cursor: pointer;
  border-radius: 8px;
  transition: 0.5s;
  width: 100%;
  &:disabled {
    background-color: grey;
  }
`;

export const Title1 = styled.div`
  font-weight: bold;
  font-size: 1.5rem;
  text-align: center;
  color: #212121;

  @media (max-width: 600px) {
    max-width: 100%;
  }
`;

export const ButtonDelete = styled.button`
  margin: 0 10px;
  padding: 8px 16px;
  font-size: 14px;
  border: none;
  background-color: transparent;
  color: #6c5af4;
  max-width: 100px;
  cursor: pointer;
  border: 1px solid #6c5af4;
  border-radius: 8px;
  transition: 0.5s;
  width: 100%;
  &:disabled {
    background-color: grey;
  }
`;

export const Container = styled.div`
  display:grid;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: auto auto;
`;

export const CommitmentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
`;

export const CommitmentsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CommitmentsTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin-bottom: 8px;
`;

export const CommitmentsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;


export const CommitmentCard = styled.div<{ status?: string }>`

  border-radius: 8px;
  border: 1px solid #ddd;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 220px;
  align-items: flex-start;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover {
    border-color: #6c5af4;
  }


`;

export const CommitmentDescription = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #333;
`;

export const CommitmentDate = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: #6c5af4;
`;

export const CommitmentIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const StatusIcon = styled.img`
  width: 18px;
  height: 18px;
`;

export const NoCommitmentsText = styled.p`
  font-size: 14px;
  color: #666;
  text-align: center;
`;

export const RefreshButton = styled.button`
  background: #6c5af4;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s;

  &:hover {
    background: #5a4ae4;
  }
`;